import { lazy } from 'react';
import { GOODPAY_MERCHANT } from '@root/constants/paths';
import { getGoodPayContentData } from '@root/constants/formData';
import { getGoodPayVerifyRoutes } from './goodpayVerifyRoutes';
import { getGoodPayRoutes } from './goodpayPayRoutes';

const Layout = lazy(() => import('@pages/goodpay/Layout'));

const { header } = getGoodPayContentData();

export const goodpayRoutes = {
  path: GOODPAY_MERCHANT,
  element: <Layout headerContent={header} />,
  children: [...getGoodPayVerifyRoutes(), ...getGoodPayRoutes()]
};
